import _ from "lodash";

export default {
  bus: new Vue({}),
  states: Vue.observable({
    user: null,
    refresh: true,
    is_open: false,
    tab: 'login',
    login_form: {
      email: '',
      password: '',
    },
    register_form: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      mobile_number: '',
    },
    loading: false,
    login_errors: {},
    register_errors: {},
  }),
  login() {
    this.states.loading = true
    this.clearLoginErrors()
    axios.post(`/login`, this.states.login_form)
      .then(resp => {
        this.authenticated(resp.data.data)
        Vue.$toast.success('You logged in successfully!');
      })
      .catch(err => {
        this.states.login_errors = err.response.data.errors
        this.toastErrorsFromResponse(err)
      })
      .finally(() => this.states.loading = false)
  },
  register() {
    this.clearRegisterErrors()
    this.states.loading = true
    axios.post(`/register`, this.states.register_form)
      .then(resp => {
        this.states.register_errors = {}
        Vue.$toast.success('You registered successfully!');
        this.authenticated(resp.data.data)
      })
      .catch(err => {
        this.states.register_errors = err.response.data.errors
        this.toastErrorsFromResponse(err)
      })
      .finally(() => this.states.loading = false)
  },
  close() {
    _.forEach({
      refresh: true,
      is_open: false,
      tab: 'login',
      loading: false,
      login_form: {
        email: '',
        password: '',
      },
      register_form: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        mobile_number: '',
      },
      login_errors: {},
      register_errors: {},
    }, (value, key) => {
      this.states[key] = value
    })
  },
  open(defaults = {}) {
    _.forEach(defaults, (value, key) => Vue.set(this.states, key, value))

    if (this.states.user !== null) {
      return this.authenticated(this.states.user)
    }

    this.states.is_open = true
  },
  switchTab(tab) {
    this.states.tab = tab
  },
  helpText() {
    return this.states.tab === 'login' ? 'Enter your credentials to log in:' : 'Fill all fields to register:'
  },
  titleText() {
    return this.states.tab === 'login' ? 'Login' : 'Register'
  },
  authenticated(user) {
    console.log('authenticated')
    if (this.states.refresh && this.states.user === null) {
      location.href = '/dashboard'
    } else {
      this.states.is_open = false
      this.states.user = user
      document.dispatchEvent(new CustomEvent('authenticated', {detail: user}))
    }
  },
  loginError(key) {
    return _.get(this.states.login_errors, `${key}.0`, false)
  },
  clearLoginErrors() {
    this.states.login_errors = {}
  },
  registerError(key) {
    return _.get(this.states.register_errors, `${key}.0`, false)
  },
  clearRegisterErrors() {
    this.states.register_errors = {}
  },
  toastErrorsFromResponse(err) {
    if (err.response && err.response.status === 422) {
      _.forEach(_.filter(err.response.data.errors, (errorBag, key) => !['email', 'password', 'first_name', 'last_name', 'mobile_number'].includes(key)), errors => {
        Vue.$toast.error(errors[0]);
      })
    }
  },
}
